<template>
  <div class="header-center">
    <header class="header-top">
      <van-nav-bar class="title-content title-contents" :title="params.title" @click-left="onClickLeft" @click-right="onClickRight" v-if="params && source !== 'app'">
        <van-icon name="arrow-left" slot="left" icon-size="24px" v-show="params.lefticon"></van-icon>

      </van-nav-bar>
      <div class="center-person">
        <img :src="user.userAvatar" class="userphoto">
        <p class="username">{{user.realName}}  <span>{{user.mobile}}</span></p>
      </div>
       <img src="../assets/images/backbutton.png" class="backbutton">
    </header>

  </div>
</template>

<script>
import { getCookie } from '@/utils/cookies'
import { mapGetters } from 'vuex'
import { NavBar, Row, Col } from 'vant'
export default {
  name: 'headers',
  components: { NavBar, Row, Col },
  props: ['params','user'],
  data () {
    return {
      source: getCookie('homedo_port'),
      showNav: false,
      rightIcon: 'fa fa-bars'
    }
  },
  created () {
    // 监听点击事件，控制导航隐藏
    window.onclick = (event) => {
      if (event.srcElement.className !== this.rightIcon) {
        this.showNav = false
      }
    }
    window.onscroll = () => {
      if (this.showNav) {
        this.showNav = false
      }
    }
  },
  computed: {
    ...mapGetters(['getMenu'])
  },
  mounted: function(){
      if ($HMD$.rNavigator === 'ios' || $HMD$.rNavigator === 'android') {
          // eslint-disable-next-line no-undef
          $HMD$.M.Ready(function () {
            // 录音开始发送消息
            $HMD$.M.sendApp({
              name:'showShare',
              value: 0
            })
          })
      }
  },
  methods: {
    onClickLeft () {
      if (window.history.length < 2) {
        window.location.href = '/'
      } else {
        window.history.back()
      }
    },
    onClickRight () {
      this.showNav = !this.showNav
    }
  }
}
</script>
<style>
.title-contents .van-nav-bar__title{
  color: #fff;
}
.header-center  .van-hairline--bottom::after{
  border-bottom-width:0
}
.header-center  .van-nav-bar .van-icon{
  font-size: 18px;
}

</style>
<style scoped lang="scss">
 .header-center{
  width:100%;
  height:auto ;
  background-color:#2F7BFF;
 }
 .header-top{
   position: relative;
   .backbutton{
     position: absolute;
     top: 20px;
     right: -20px;
     width: 140px;
     height: 140px;
     z-index: 1111;
   }
 }
.title-content{
  font-size: 19px;
  color: #fff;
  background-color: #2F7BFF;
}
.title-content .van-icon{
  color: #fff;
}
.nav-content .van-icon{
  color: #fff;
  font-size: 24px;
}
.nav-content{
  padding-top: 10px;
  width: 100%;
  height: 58px;
  position: fixed;
  top: 44px;
  text-align: center;
  background: rgba(0, 0, 0, 0.75);
  z-index: 100;
  box-sizing: border-box;
}
.nav-content div{
  color: #fff;
}
.m-t-3{
  margin-top: 3px;
}
.center-person{
  height: 104px;
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 0 16px;
  .userphoto{
    width: 59px;
    height: 59px;
    border-radius: 50%;
  }
  .username{
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    padding-left: 10px;
    span{
      font-size: 12px;
      font-weight: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headerCenter.vue